import { AppBar, Grid, Typography } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useState } from "react";
import { Wizard } from "../../../components";
import { ScheduleOneOnOne } from "../../../mentor/components/schedule-one-on-one";
import ScheduleButton from "../../../mentor/components/schedule-one-on-one/schedule-button.component";
import type { MxQuickWin } from "../../../models/gameplan";
import { LinkKeepUTM } from "../../../shared/components/LinkKeepUTM";
import { Button } from "../../../shared/components/button";
import { useInIframe } from "../../../shared/hooks";
import { FruitionLogo } from "../../../shared/icons";
import { QuickwinHeader } from "../../components/quickwin-header/quickwin-header.component";
import { learningPathStyles } from "./learning-path.styles";

export const LearningPath = () => {
  const classes = learningPathStyles();
  const isInIframe = useInIframe();
  const [completedQuickWin, setCompletedQuickWin] = useState(false);
  const [mxQuickWin, setMxQuickWin] = useState<MxQuickWin>({
    quickWin: "wizard",
  });

  function transformActionStep(input: string): string {
    return input.replace(/\s/g, "").toLowerCase();
  }

  const components = {
    wizard: <Wizard setMxQuickWin={setMxQuickWin} />,
    oneonone: (
      <>
        <QuickwinHeader
          completedQuickWin={completedQuickWin}
          quickwin="oneOnOne"
          id={mxQuickWin.id}
          goToQuickwins={setMxQuickWin}
        />
        <div className={classes.oneOnOneQuickWin}>
          <ScheduleOneOnOne
            isQuickWin={true}
            setCompletedQuickWin={setCompletedQuickWin}
          >
            {({ onClick, isButtonDisabled }) => (
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  onClick={() =>
                    setMxQuickWin({ quickWin: "wizard", id: undefined })
                  }
                  variant="text"
                >
                  Cancel
                </Button>
                <Grid item md={5}>
                  <ScheduleButton
                    onClick={onClick}
                    disabled={isButtonDisabled}
                  />
                </Grid>
              </Grid>
            )}
          </ScheduleOneOnOne>
        </div>
      </>
    ),
  };

  return (
    <Grid container className={classes.container}>
      <AppBar className={classes.appContainer}>
        <Grid className={classes.innerContainer} container>
          <Grid item lg={1} md={2} sm={2} xs={3}>
            <LinkKeepUTM to="/participant/learning">
              <Typography variant="body1">
                <ArrowBackIosIcon /> Go Back
              </Typography>
            </LinkKeepUTM>
          </Grid>
          <div className={classes.imageContainer}>
            {!isInIframe && (
              <LinkKeepUTM to="/participant/dashboard">
                <FruitionLogo />
              </LinkKeepUTM>
            )}
          </div>
        </Grid>
      </AppBar>
      {components[transformActionStep(mxQuickWin.quickWin || "wizard")]}
    </Grid>
  );
};
